import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class TaxonomyParser implements Parser {
	parse(schema: Record<string, Schema.CategoryContentType>) {
		const names = Object.keys(schema).map((name) => `"${name}"`);

		return names.length
			? `export type TaxonomyContentTypes = ${names.join("|")}`
			: "";
	}
}
